import React, { useState, useContext, useEffect } from 'react'
import { Table } from 'antd'
import { formatDateFromTimestamp, withEmptyRender } from '@utils/common'
import fetch from '@utils/request'
import api from '@api'
import usePagination from '@hooks/usePagination'
import PatientContext from '../context'

const Pathology = ({ targetPage, render }) => {
  const { activeVisit, projectId, patientId } = useContext(PatientContext)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage, setTotal, pagination] = usePagination({
    initialPage: {
      pageIndex: targetPage || 1,
      pageSize: 10,
    },
  })
  const columns = withEmptyRender([
    {
      title: '申请单号',
      dataIndex: 'pathology_request_no',
      render,
    },
    {
      title: '标准检查项目编码',
      dataIndex: 'standard_exam_item_code',
      render,
    },
    {
      title: '标准检查项目编码',
      dataIndex: 'standard_exam_item_name',
      render,
    },
    {
      title: '源检查项目编码',
      dataIndex: 'origin_exam_item_code',
      render,
    },
    {
      title: '源检查项目编码',
      dataIndex: 'origin_exam_item_name',
      render,
    },
    {
      title: '检查时间',
      dataIndex: 'exec_time',
      render: (value, record) => render(formatDateFromTimestamp(value) || '-', record),
    },
    {
      title: '报告时间',
      dataIndex: 'report_time',
      render: (value, record) => render(formatDateFromTimestamp(value) || '-', record),
    },
    {
      title: '送检样本',
      dataIndex: 'sample_type_name',
      render,
    },
    {
      title: '肉眼所见',
      dataIndex: 'beSeen_visually',
      render,
    },
    {
      title: '镜下所见',
      dataIndex: 'microscopic_findings',
      render,
    },
    {
      title: '病理诊断',
      dataIndex: 'diag_desc',
      render,
    },
  ])

  const handleTableChange = (pagination) => {
    setPage({
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
    })
  }
  const fetchRecord = async () => {
    const pager = {
      pageNumber: page.pageIndex,
      pageSize: page.pageSize,
    }
    setLoading(true)
    const { indexNo, type } = activeVisit
    const { content, totalCount } = await fetch({
      url: api.patientApi.patientRecords,
      method: 'GET',
      params: {
        patientId,
        indexNo,
        type: 5,
        category: type,
        proId: projectId,
        ...pager,
      },
    })
    setData(content)
    setLoading(false)
    setTotal(totalCount)
  }

  useEffect(() => {
    if (patientId) {
      fetchRecord()
    }
  }, [activeVisit, page])

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey={(record) => record.id}
        size="small"
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        scroll={{ x: 'max-content' }}
      />
    </>
  )
}

export default Pathology
